export enum CustomerEndpoints {
  NEWSLETTER_SUBSCRIBE = '/newsletter/subscribe',
  NEWSLETTER_UNSUBSCRIBE = '/newsletter/unsubscribe',
  SUBSCRIPTION_STATUS = '/newsletter/subscription-status',
  NEWSLETTER_RESUBSCRIBE = '/newsletter/resubscribe',
  ORDER_BROCHURE = '/brochure/order'
}
